<template>
  <div class="flex items-center gap-2.5 px-3.5 py-2.5 rounded-sm border border-christine bg-[#FDEEE6]">
    <svg class="w-[22px] h-[22px] flex-none text-christine-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <path d="M12 4 2.5 20h19L12 4Z" stroke-linejoin="round" />
      <path d="M12 10v4.5M12 17.2v.1" stroke-linecap="round" />
    </svg>
    <span class="font-chivo font-semibold text-[17px] leading-tight">{{ t('components.financingCalculator.warning') }}</span>
  </div>
</template>

<script setup lang="ts">
  // "Achtung! Fahrzeugfinanzierungen kosten Geld." – required wherever a financing example is shown.
  const { t } = useI18n();
</script>
